import _ from 'lodash'


/**
 * @typedef {Object} FilterOption
 * @property {string} extName
 * @property {string} title
 */

/**
 * @typedef {Object} Filter
 * @property {string} extName
 * @property {string} title
 * @property {Array<FilterOption>} options
 * @property {boolean} multipleSelections
 */

/**
 * @typedef {Object} FilterItem
 * @property {Filter} filter
 * @property {FilterOption} option
 */

/**
 * @typedef {Object} FilterGroup
 * @property {string} key
 * @property {string} title
 * @property {boolean} expanded
 * @property {boolean} ungrouped
 * @property {boolean} flatten
 * @property {Array<Filter>} filters
 */

/**
 * @typedef {Object} FilterSet
 * @property {string} surveyExtName
 * @property {string} type
 * @property {Array<FilterGroup>} filterGroups
 */



function CombinedFilters (/*initialFilters*/) {
  this.filterMap = new Map()
//  this.setFilters(initialFilters)
//   console.log("Filter init: " + initialFilters)
}

// NOT counting z and tz
CombinedFilters.prototype.getNumberOfSelectedFilters = function () {
  let counter = 0

  for (const [key, value] of this.filterMap.entries()) {
    if(key!=='z' && key!=='vz' && value && value.length>0) {
      counter++
    }
  }

  return counter
}

CombinedFilters.prototype.getSelectedFilterOptions = function (filterName) {
  let values = this.filterMap.get(filterName)
  return values ? values : []
}

CombinedFilters.prototype.setFilterOptions = function (filterName, filterOptions) {
  // console.log("setFilterOptions called: " + filterName + "=" + filterOptions + " len=" + filterOptions.length)
  this.filterMap.set(filterName, filterOptions)
  this.filterMap = new Map(this.filterMap)   // vue.js doesn't handle reactivity on Map
  // console.log("asToken: " + this.asTokenString())
}


CombinedFilters.prototype.asTokenString = function () {
  let result = []

  for (const [key, value] of this.filterMap.entries()) {
    if(value && 0 !== value.length && value[0]) {
      const optionNames = value.map(option => { return option.extName } )
      result.push( key+"="+optionNames.join(','))
    }
  }

  // console.log("")

  return result.join(';')
}



// input like: z=2019;vz=2018
CombinedFilters.prototype.setFiltersFromTokenString = function (filterSet, tokenString) {
//  console.log("setFiltersFromTokenString:" + tokenString)

  let parts = tokenString.trim().split(';')
  for (let f of parts) {
    if (f !== '') {
      const nameoptions = this.getFilterOptions(filterSet, f)

      // console.log("filter")
      // console.log(f)
      // console.log(nameoptions)

      this.setFilterOptions(nameoptions.filterName, nameoptions.filterOptions)
    }
  }

//  console.log("Done setting - tokens now:" + this.asTokenString())
}



// input z=2019
// returns: { filterName, [filterOptions]}
CombinedFilters.prototype.getFilterOptions = function (filterSet, filterToken) {
  const keyValue = _.split(filterToken, '=', 2)

  if(keyValue.length!==2) {
    return null
  }

  const filterName = keyValue[0]
  const filterValues = keyValue[1]

  let filterDef = null
  if(filterName==='z') {
    filterDef = filterSet.selectionTimeFilter
  } else if(filterName==='vz') {
    filterDef = filterSet.trendTimeFilter
  } else {
    filterDef = _.find(filterSet.filterDefs, { extName: filterName} )
  }

  if(!filterDef) {
    return null
  }

  const valueList = _.split(filterValues, ',')

  const options = []

  for( let v of valueList) {
     const fo = _.find(filterDef.options, { extName: v })
    if(fo!==null) {
      options.push(fo)
    }
  }

  return { filterName: filterDef.extName, filterOptions: options}
}


export default CombinedFilters
